import { useTranslation } from 'react-i18next'
import type { MeterSupplyEntry } from '../../api/schema'
import { cn } from '../../lib/utils'

const TONE: Record<MeterSupplyEntry['status'], string> = {
  covered: 'bg-success/10 text-success',
  unlinked: 'bg-warning/10 text-warning',
  lapsed: 'bg-warning/10 text-warning',
  missing: 'bg-destructive/10 text-destructive',
}

/**
 * The supply status of a meter as a small chip (spec 2026-10-27-16 §2): on the
 * Equipment tab's metering rows, and on the meter card. A meter that needs no
 * contract of its own says nothing here.
 */
export function MeterSupplyStatusChip({ entry, testId }: { entry: MeterSupplyEntry; testId?: string }) {
  const { t } = useTranslation('assets')
  if (!entry.in_scope) return null
  return (
    <span
      className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium', TONE[entry.status])}
      data-testid={testId ?? `meter-supply-chip-${entry.asset.uid}`}
      data-status={entry.status}
    >
      {t(`meter_supply.status.${entry.status}`)}
    </span>
  )
}
